import React, { Component } from 'react';
import { EditorState } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import $ from 'jquery';
import ReactPlayer from 'react-player';
import { ToastContainer, toast } from "react-toastify";
import * as Loader from 'react-loader-spinner';



export default class ContentPreview extends Component {
    constructor() {
        super();


        this.state = {
            docCharacterCount: 0,
            errorMsg: '',
            selectedOption: "uploadFileContent",
            uploadURLContent: false,
            imgContent: '',
            callFileContentApi: false,
            type: '',
            contentId: '',
            editorState: EditorState.createEmpty(),
            existingContentInfo: {
                documentSections: [],
                subFolderList: [],
                folderTitle: "Home"
            },
            folderId: "00000000-0000-0000-0000-000000000000",
            folderPathName: 'Home',
            showNoData: false,
            addedFolderInfo: [],
            iconFile: '',
            imageContentType: false,
            videoContentType: false,
            audioContentType: false,
            textContentType: true,
            showAddFolderOverLay: false,
            showAddContentOverLay: false,
            documentList: [],
            showLoader: false,
            editedId: -1,
            languageList: [],
            language: '',
            hideDeletePopup: false,
            hideDeletePublishPopup: false,
            hideDeleteUnpublishPopup: false,
            published: false,
            showBackButton: false,
            folderIds: [],
            isFolderEmpty: false,
            folderHeading: "",
            folderHeadings: [],
            moreCharacters: false,
            folderPath: [
                {
                    id: "00000000-0000-0000-0000-000000000000",
                    label: "Home",
                    depth: 0
                }
            ]
        }
        this.reactPlayerRefs = [];
    }
    componentDidMount() {
        var thisController = this;
        window.addEventListener('message', this.handleMessage, false);
        setTimeout(() => {
            thisController.fetchContent();
        }, 300);


    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleMessage, false);
    }

    handleMessage = (event) => {
        if (event.data === 'stopVideo') {
            // Stop all native HTML video elements
            var videos = document.querySelectorAll('video');
            videos.forEach((video) => {
                video.pause();
                video.currentTime = 0; // Reset video to the beginning
            });

            // Stop all native HTML audio elements
            var audios = document.querySelectorAll('audio');
            audios.forEach((audio) => {
                audio.pause();
                audio.currentTime = 0; // Reset audio to the beginning
            });
            
            // Stop all ReactPlayer instances
            this.reactPlayerRefs.forEach(player => {
                if (player) {
                    player.seekTo(0);
                    player.getInternalPlayer().pause();
                }
            });
        }
    }

    previewMode = () => {
        //document.getElementById("contentId").value = "";

        this.state.showpreviewModeOverLay = true;
        this.setState(this.state);
    }


    closeAddFolderoverLay = () => {
        this.state.showAddFolderOverLay = false;
        this.setState(this.state);
    }
    closeAddContentOverLay = () => {

        this.state.showAddContentOverLay = false;
        this.setState(this.state);
    }
    closepreviewModeOverLay = () => {
        this.state.showpreviewModeOverLay = false;
        this.setState(this.state);
    }
    fetchFolder() {
        var fetchController = this;
        $.ajax({
            url: '/my-jeeva-api/folder',

            method: 'GET',
            data: {
                parentId: fetchController.state.folderId
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    if (res.result.length == 0) {
                        fetchController.state.showNoData = true;
                        fetchController.state.addedFolderInfo = res.result;
                        fetchController.setState(fetchController.state);
                    } else {
                        fetchController.state.showNoData = false;
                        fetchController.state.addedFolderInfo = res.result;
                        fetchController.state.showAddFolderOverLay = false;
                        fetchController.setState(fetchController.state);
                    }
                }
            }
        })
    }



    fetchContent() {
        var thisController = this;
        var scopeGroups = [];
        scopeGroups.push(localStorage.getItem("treatmentId"));
       var parentFolderId = localStorage.getItem("parentFolderId")
       if(parentFolderId != "00000000-0000-0000-0000-000000000000")
       {
        thisController.state.showBackButton = true;
        thisController.setState(thisController.state);
       }
        $.ajax({
            url: '/my-jeeva-api/library-module-admin/content',

            method: 'GET',
            data: {
                scopeGroup: localStorage.getItem("treatmentId"),
                scopeGroups: JSON.stringify(scopeGroups),
                scope: "TREATMENT",
                //parentFolderId: thisController.state.folderId
                 parentFolderId: parentFolderId

            },
            success: function (res) {
                if (res.success == true) {
                    if (res.result.subFolderList.length == 0 && res.result.documentSections.length == 0) {
                        thisController.state.isFolderEmpty = true;
                    }
                    thisController.state.existingContentInfo = res.result;
                    thisController.setState(thisController.state);

                }
            }
        })
    }
    fetchStream(mediaId) {
        var fetchController = this;

        $.ajax({
            url: '/my-jeeva-api/stream',

            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            data: {
                mediaId: mediaId

            },
            success: function (res) {
                if (res.success == true) {
                    console.log("done with streaming");
                }
            }
        })
    }
    fetchMedia(mediaId) {
        var fetchController = this;

        $.ajax({
            url: '/my-jeeva-api/media',

            method: 'GET',

            data: {
                mediaId: mediaId

            },
            success: function (res) {
                fetchController.state.mediaUrl = res;
                fetchController.setState(fetchController.state);
            }
        })
    }



    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    handleMouseEnterDoc = (id) => {
        this.state.hoverId = id;
        this.setState(this.state);
    }
    handleMouseLeaveDoc = () => {
        this.state.hoverId = -1;
        this.setState(this.state);
    }
    makeCelleditSubFolder(index) {
        this.markAsBeingEdited(this.state.existingContentInfo.subFolderList[index].id);
    }
    makeCelleditSection(index) {
        this.markAsBeingEdited(this.state.existingContentInfo.documentSections[index].id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    onFolderClick(id, label) {
        this.state.folderId = id;
        localStorage.setItem("parentFolderId",this.state.folderId)
        this.state.folderHeading = label;
        this.setState(this.state);
        this.fetchContent(true);

        // for headings 
        if (this.state.folderHeading.length > 18) {
            this.state.moreCharacters = true;
        } else {
            this.state.moreCharacters = false;
        }
        this.state.folderHeadings.unshift(this.state.folderHeading);

        if (this.state.folderId == "00000000-0000-0000-0000-000000000000") {
            this.state.isFolderEmpty = false;
            this.state.showBackButton = false;
            this.state.folderHeading = "";
        }
        if (this.state.folderId != "00000000-0000-0000-0000-000000000000") {
            this.state.showBackButton = true;
        }
        if ((this.state.folderIds[this.state.folderIds.length - 1] != "00000000-0000-0000-0000-000000000000") || (this.state.folderIds.length == 0)) {
            this.state.folderIds.push("00000000-0000-0000-0000-000000000000");
            this.state.folderIds.unshift(this.state.folderId);
        } else {
            this.state.folderIds.unshift(this.state.folderId);
        }
    }

    goBack = () => {
        if (this.state.folderIds.length > 1) {
            this.state.folderIds.shift(this.state.folderId);
            this.state.folderId = this.state.folderIds.at(0);
            localStorage.setItem("parentFolderId",this.state.folderId)
            // for headings
            if (this.state.folderHeading.length > 18) {
                this.state.moreCharacters = true;
            } else {
                this.state.moreCharacters = false;
            }
            this.state.folderHeadings.shift(this.state.folderHeading);
            this.state.folderHeading = this.state.folderHeadings.at(0);

            if (this.state.folderId == "00000000-0000-0000-0000-000000000000") {
                this.state.showBackButton = false;
            }
            this.setState(this.state);
        } else {
            this.state.folderId = "00000000-0000-0000-0000-000000000000";
            localStorage.setItem("parentFolderId",this.state.folderId)
            this.state.folderIds = [];
            this.state.folderHeadings = [];
            this.state.showBackButton = false;
            this.setState(this.state);
        }
        this.state.isFolderEmpty = false;
        // this.state.folderHeading = "Back"
        this.fetchContent(true);
        this.setState(this.state);
    }




    sectionTemplate(section) {
        switch (section.type) {
            case 'TEXT': 
            
            const htmlContent = section.textContent;
            const modifiedHtmlContent = htmlContent.replace(
              /background-color:\s*[^;]+;/g,
              'background-color: black;'
            );
            return (

                


                <div className='col-sm-9'>

                    <div className="textarea"
                        style={{
                            marginTop: '1vw', marginBottom: '1vw',
                            borderRadius: '10px',
                            padding: '6px', height: 'auto',
                            color: '#fff'
                        }} dangerouslySetInnerHTML={{ __html: modifiedHtmlContent }}></div>
                </div>
            );
            case 'IMAGE':
                var mediaUrl;
                if (section.mediaUrl != null) {
                    mediaUrl = section.mediaUrl;
                } else if (section.mediaId != null) {
                    mediaUrl = "/my-jeeva-api/media/" + section.mediaId;
                } else {
                    mediaUrl = "/assets/images/not-available.jpg";
                }
                return (
                    // <div>
                    //     <div className='col-sm-2'>
                    //         <label style={{ marginLeft: '1vw', marginTop: '1vw' }}>{section.caption}</label>
                    //     </div>
                    <div className='col-sm-9'>
                        <div className="sectionImage" id={"sectionImage" + section.id}
                            style={{
                                borderRadius: '10px', margin: '10px',
                                padding: '6px', height: 'auto',
                                textAlign: 'center', borderRadius: '12px', marginBottom: '10px'
                            }}><img src={mediaUrl} style={{ maxWidth: '50vw', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}></img></div>

                    </div>
                    // </div>
                );
            case 'VIDEO':
                var mediaUrl;
                if (section.mediaUrl != null) {
                    mediaUrl = section.mediaUrl;
                } else if (section.mediaId != null) {
                    mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
                } else {
                    mediaUrl = "/assets/images/not-available.jpg";
                }
                var youtubeVideoPattern = new RegExp(/^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/);

                return (
                    <div className='col-sm-9'>
                        {!youtubeVideoPattern.test(mediaUrl) ?
                            <div className="sectionVideo" id={"sectionVideo" + section.id}
                                style={{
                                    borderRadius: '10px', height: 'auto',
                                    textAlign: 'center'
                                }}>
                                <video width="360px" height="360px" controls disablePictureInPicture controlsList="nodownload" >
                                    <source src={mediaUrl} type="video/mp4" />
                                </video>
                            </div>
                            :
                            <div className="sectionVideo" id={"sectionVideo" + section.id}
                                style={{
                                    borderRadius: '10px', height: 'auto',
                                    textAlign: 'center'
                                }}>
                                <ReactPlayer 
                                 ref={(player) => { this.reactPlayerRefs.push(player) }}
                                url={mediaUrl} width="360px" height="360px" controls />
                            </div>}

                    </div>

                );
            case 'AUDIO':
                var mediaUrl;
                if (section.mediaUrl != null) {
                    mediaUrl = section.mediaUrl;
                } else if (section.mediaId != null) {
                    mediaUrl = "/my-jeeva-api/stream/" + section.mediaId;
                } else {
                    mediaUrl = "/assets/images/not-available.jpg";
                }
                var onlineMusicAppPattern = new RegExp(/^(?:https?:\/\/)?(?:www\.)?(?:soundcloud\.com|snd\.sc)\/([a-zA-Z0-9-_]+)\/(?:(?:sets\/)?([a-zA-Z0-9-_]+)|(?:[^\/?]+))(?:\?.*)?$/);

                return (
                    <div className='col-sm-9'>
                        {!onlineMusicAppPattern.test(mediaUrl) ?
                            <div className="sectionAudio" id={"sectionAudio" + section.id}
                                style={{
                                    borderRadius: '10px', margin: '10px',
                                    padding: '6px', height: 'auto',
                                    textAlign: 'center'
                                }}>
                                <audio controlsList="nodownload" controls style={{ width: '70vw' }}>
                                    <source src={mediaUrl} type="audio/mpeg" style={{ maxWidth: '70vw', textDecoration: 'underline', color: 'blue', cursor: 'pointer' }} />
                                </audio>
                                {/* <audio src={mediaUrl} ></audio> */}
                            </div>
                            :
                            <div className="sectionAudio" id={"sectionAudio" + section.id}
                                style={{
                                    borderRadius: '10px', margin: '10px',
                                    padding: '6px', height: 'auto',
                                    textAlign: 'center'
                                }}>
                                <ReactPlayer 
                                 ref={(player) => { this.reactPlayerRefs.push(player) }}
                                url={mediaUrl} width="360px" height="360px" controls controlsList="nodownload" />
                            </div>}
                    </div>
                    // </div>
                );
        }
    }

    render() {
        return (
            <div>
                <div style={{ background: 'black' }}>

                    <link href="./patientapp_assets/css/index.css" rel="stylesheet" />
                    <link href="./patientapp_assets/css/appContentpreview.css" rel="stylesheet" />



                    <header className="main-header" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "2rem", height: "2.5rem" }}></div>
                        <img src="./patientapp_assets/img/logo.jpg" alt="" style={{ width: "3.6rem" }} />
                        <div style={{ border: "1px solid", borderRadius: "50%" }}><img src="./patientapp_assets/img/account-button-new.png" className="imgright" alt="" style={{width:"2.3rem",borderRadius:"50%"}}/></div>
                        <title>Account</title>
                    </header>

                    <div className='headersection' style={{ display: this.state.showBackButton === true ? "flex" : "none", height: '5.5vh', position: 'sticky', top: '7.6vh', backgroungColor: 'black', zIndex:"3" }} >
                        <img src="./patientapp_assets/img/arrowBack.png"
                            style={{ paddingRight: "30%", marginLeft: "5vw", height: "4vh", paddingTop: "1vh", cursor:"pointer" }}
                            onClick={this.goBack}
                        />
                        <h2 id='folderHeading' style={{ color: 'white', marginLeft: this.state.moreCharacters ? "-20vw" : "-10vw" }}> {this.state.folderHeading} </h2>
                    </div>

                    <div className="main-content" style={{height: this.state.showBackButton ? "71vh" : "76vh"}}>
                        {this.state.existingContentInfo.documentSections.map((section, i) => (
                            <div className='fontpreviewBox' style={{ border: 'none', marginTop: '1vw' }} key={i}>
                                <div className={section.caption != null ? 'row' : ''}>
                                    <label style={{ display: section.caption != null ? 'block' : 'none', marginTop: '1vw', marginLeft: '2vw', fontWeight: '430', fontSize: '18px' }}>{section.caption}</label>
                                </div>
                                <div className='row'>

                                    {this.sectionTemplate(section)}

                                </div>
                            </div>
                        ))}

                        {this.state.existingContentInfo.subFolderList.map((el, i) => (
                            <div key={i} onClick={
                                (function (controller, folderId, label) {
                                    var thisFolderId = folderId;
                                    var thisLabel = label;
                                    return function () {
                                        controller.onFolderClick(thisFolderId, thisLabel);
                                    }
                                })(this, this.state.existingContentInfo.subFolderList[i].id, this.state.existingContentInfo.subFolderList[i].label)} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>

                                <div className="col1">
                                    <img style={{ width: '76px', height: '76px', borderRadius: '12px' }} src={"data:png;base64," + this.state.existingContentInfo.subFolderList[i].icon}
                                    />
                                </div><div className="col2" style={{
                              cursor: "pointer",
                            //   height: "81px",
                              width: "66vw",
                              display: "inline-block",
                              wordWrap: "break-word",


                            }}>
                                    <h2 style={{ 
                                        // overflowX: "scroll",
                                         whiteSpace: "nowrap" }}>{this.state.existingContentInfo.subFolderList[i].label}</h2>
                                    <div  style={{
                                height: "50px",
                                overflowX: "scroll",
                                wordWrap: "break-word",
                                width: "65vw"}} className='desc-content'>
                                    {this.state.existingContentInfo.subFolderList[i].description} </div>
                                </div>
                                <br />
                            </div>
                        ))}

                        <div className='col2' style={{ display: this.state.isFolderEmpty === true ? "block" : "none" }} >
                            <h3>No Content here</h3>
                        </div>
                    </div>

                    <footer className="main-footer">
                        <div className="box">
                            <div><img src="./patientapp_assets/img/info-button.jpg" alt="" /><br />Home</div>
                            <div><img src="./patientapp_assets/img/survey-button.jpg" alt="" /><br />Survey</div>
                            <div><img src="./patientapp_assets/img/profile-symbol.jpg" alt="" /><br />JEEVA</div>
                            <div><img src="./patientapp_assets/img/journal-button.jpg" alt="" /><br />Journal</div>
                            <div><img src="./patientapp_assets/img/phone-button.jpg" alt="" style={{
                                textDecoration: 'none',
                                backgroundColor: 'transparent', mixBlendMode: 'lighten'
                            }} /><br />Contact Us</div>

                        </div>
                    </footer>
                </div>
            </div >

        );
    }
}


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ContentPreview.js